import { useMemo } from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import type { EnginGasoilRow } from '@/types';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface EnginBarChartProps {
  data: EnginGasoilRow[];
}

export default function EnginBarChart({ data }: EnginBarChartProps) {
  const chartData = useMemo(() => {
    const sorted = [...data].sort((a, b) => (b.quantite ?? 0) - (a.quantite ?? 0));
    const labels = sorted.map((d) => d.engin?.code ?? '');
    const values = sorted.map((d) => d.quantite ?? 0);
    return {
      labels,
      datasets: [
        {
          label: 'Quantité',
          data: values,
          backgroundColor: 'rgba(20, 184, 166, 0.5)',
          borderColor: 'rgb(20, 184, 166)',
          borderWidth: 1,
        },
      ],
    };
  }, [data]);

  const options = useMemo(
    () => ({
      indexAxis: 'y' as const,
      responsive: true,
      plugins: {
        legend: { display: false },
        title: { display: true, text: 'Total consommations' },
      },
      scales: {
        x: { beginAtZero: true },
      },
    }),
    []
  );

  if (!data.length) {
    return (
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-8 text-center text-slate-600">
        Aucune donnée pour le graphique
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <Bar data={chartData} options={options} />
    </div>
  );
}
